import React from "react";
import logo from "../../../images/logo/white-ontrack-logo.jpeg";
import { MdOutlineEmail } from "react-icons/md";
import { useNavigate } from "react-router-dom";
const ResendOtp = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full flex flex-col items-center justify-center p-8 bg-white">
      <img
        src={logo}
        alt="LogIn Info"
        className="absolute top-4 left-4 w-28 h-auto hover:cursor-pointer"
        onClick={() => navigate("/")}
      />
      <h1 className="text-3xl font-bold text-purple-800 mb-2">Re-send OTP</h1>
      <p className="text-gray-500 mb-6 mt-6">
        Didn't receive the OTP? Request a new one to continue.
      </p>
      <form className="w-full max-w-md">
        <div className="mb-6">
          <div className="flex items-center border border-gray-300 rounded px-3 py-2">
            <MdOutlineEmail className="mr-2" />
            <input
              type="email"
              placeholder="Your registered email address"
              className="w-full outline-none text-gray-700"
            />
          </div>
        </div>

        <button
          onClick={(e) => {
            navigate("/auth/otp", { state: { from: "/auth/resend-otp" } });
          }}
          className="w-full py-3 text-white bg-gradient-to-r from-pink-500 to-blue-700 rounded-lg shadow-md hover:opacity-90 transition-all"
        >
          Send OTP
        </button>
      </form>
    </div>
  );
};

export default ResendOtp;
